import {getStorageInfo} from "../common/js/storage";
import {getUserType} from "../common/constant/org";
import {getActivityModuleIds} from "../common/activity/activity";

export const moduleList = [
    {
        title: '工作人员管理',
        key: 'staff',
        routers: ['ActivityStaff'],
    },
    {
        title: '活动日程',
        key: 'group',
        routers: ['ActivityGroup']
    },
    {
        title: '会议室预约',
        key: 'meeting',
        path: 'meeting-room',
        // notMenu: true, // 不显示在左侧菜单栏
        routers: ['ActivityMeetingRoom']
    },
    {
        title: '首页装修',
        key: 'furnish',
        children: [
            { title: '首页预览', key: 'furnish-preview', path: 'home-preview', routers: ['ActivityHomePreview'] },
            { title: '官方日程', key: 'furnish-schedule', path: 'schedule', routers: ['ActivitySchedule'] },
            { title: '文章列表', key: 'furnish-article', path: 'article', routers: ['ActivityArticle'] },
            { title: '视频列表', key: 'furnish-video', path: 'video', routers: ['ActivityVideo'] },
        ]
    },
    {
        title: '嘉宾管理',
        key: 'guest',
        path: 'person',
        children: [
            { title: '嘉宾邀请', key: 'guest-invite', path: 'guest', routers: ['ActivityGuest'] },
            { title: '嘉宾审核', key: 'guest-verify', routers: ['ActivityGuestVerify'] },
        ]
    },
    {
        title: '导览管理',
        key: 'location',
        routers: ['ActivityLocation']
    },
    {
        title: '报名管理',
        key: 'enroll',
        routers: ['ActivityEnroll']
    },
    {
        title: '用餐管理',
        key: 'meal',
        path: 'dinner',
        children: [
            { title: '用餐分配', key: 'meal-assign', routers: ['ActivityMealAssign'] },
            { title: '用餐信息', key: 'meal-info', routers: ['ActivityMealInfo'] },
            { title: '用餐规格', key: 'meal-type', path: 'meal', routers: ['ActivityMeal'] },
        ]
    },
    {
        title: '订餐服务',
        key: 'food',
        children: [
            { title: '订餐管理', key: 'food-order', routers: ['ActivityFoodOrder'] },
            { title: '餐品管理', key: 'food-type', routers: ['ActivityFoodType'] },
            { title: '订餐时间管理', key: 'food-time', routers: ['ActivityFoodTime'] },
            { title: '订餐设置', key: 'food-set', routers: ['ActivityFoodSet'] },
        ]
    },
    {
        title: '住宿管理',
        key: 'stay',
        children: [
            { title: '住宿分配', key: 'stay-assign', routers: ['ActivityStayAssign'] },
            { title: '住宿信息', key: 'stay-info', routers: ['ActivityStayInfo'] },
            { title: '酒店管理', key: 'stay-hotel', path: 'hotel', routers: ['ActivityHotel'] },
            { title: '房型管理', key: 'stay-room', path: 'room', routers: ['ActivityRoom'] },
        ]
    },
    {
        title: '礼品管理',
        key: 'gift',
        path: 'present',
        children: [
            { title: '礼品分配', key: 'gift-assign', routers: ['ActivityGiftAssign'] },
            { title: '礼品规格', key: 'gift-type', path: 'gift', routers: ['ActivityGift'] },
        ]
    },
    {
        title: '交通管理',
        key: 'traffic',
        children: [
            { title: '车辆分配', key: 'traffic-assign', path: 'vehicle-assign', routers: ['ActivityVehicleAssign', 'ActivityJourney'] },
            { title: '行程信息', key: 'traffic-info', path: 'travel-info', routers: ['ActivityTravelInfo', 'ActivityGuestInfo'] },
            { title: '司机管理', key: 'traffic-driver', path: 'driver', routers: ['ActivityDriver'] },
            { title: '车辆管理', key: 'traffic-vehicle', path: 'vehicle', routers: ['ActivityVehicle'] },
            { title: '通行证管理', key: 'traffic-pass', path: 'pass', routers: ['ActivityPass'] },
        ]
    },
    {
        title: '送机服务',
        key: 'delivery',
        children: [
            { title: '预约列表', key: 'delivery-list', routers: ['ActivityDeliveryList', 'ActivityDeliveryDetail'] },
            { title: '车型管理', key: 'delivery-car', routers: ['ActivityDeliveryCar'] },
            { title: '送机服务设置', key: 'delivery-set', routers: ['ActivityDeliverySet'] },
        ]
    },
    {
        title: '接待人员管理',
        key: 'receptionist',
        routers: ['ActivityReceptionist']
    }
];


const getUserActivityModules = function (activity, user) {
    user = user || getStorageInfo();
    const type = getUserType(user);
    let modules = [];
    switch (type) {
        case 1:
            modules = moduleList;
            break;
        default:
            if(activity.charge_status > 0) {
                modules = moduleList;
            } else {
                const idList = getActivityModuleIds(activity);
                moduleList.forEach(m => {
                    const children = [];
                    if(m.children) {
                        m.children.forEach(c => {
                            if(idList.indexOf(c.key) >= 0) {
                                children.push(c);
                            }
                        });
                    }
                    if(children.length > 0 || idList.indexOf(m.key) >= 0) {
                        let temp = { ...m };
                        if(children.length > 0) {
                            if(children.length == 1) {
                                temp = children[0]
                            } else {
                                temp.children = children;
                            }
                        }
                        modules.push(temp);
                    }
                });
            }
            break;
    }
    return modules;
}

export const getActivityRouterMenus = function (activity, routers, menus, modules) {
    const id = activity.id;
    if(!routers) {
        routers = ['ActivityInfo', 'ActivityDetail', 'ActivityGroup'];
        // 统筹人 统筹小组成员可以看到活动概览
        if(activity.charge_status > 0) {
            menus = [{title: '活动概览', path: `/act/${id}/info`}];
        } else {
            // 普通工作人员默认可以看到活动基本信息
            menus = [{title: '活动详情', path: `/act/${id}/detail`}];
        }
    }
    modules = modules || getUserActivityModules(activity);
    modules.forEach(m => {
        const menu = {title: m.title,path: `/act/${id}/${m.path || m.key}`};
        if(m.routers) {
            m.routers.forEach(r => {
                if(routers.indexOf(r) === -1) {
                    routers.push(r);
                }
            });
        }
        if(m.children) {
            // 递归调用获取子菜单并将加入路由数组
            const {menus: children} = getActivityRouterMenus(activity, routers, [], m.children);
            menu.children = children;
        }
        if(!m.notMenu) {
            menus.push(menu);
        }
    });
    return {routers, menus, modules};
}
